var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerReferrals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1017,
    height: 258,
    viewBox: "0 0 1017 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_429_17537)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 1016,
    height: 258,
    rx: 12,
    fill: "url(#paint0_linear_429_17537)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.691 86.0227C153.691 85.9737 153.693 85.9251 153.693 85.8761C153.693 59.2633 132.283 37.6895 105.872 37.6895C86.2904 37.6895 69.4604 49.5514 62.0654 66.5317C60.1896 66.2063 58.2619 66.0346 56.2941 66.0346C37.6515 66.0346 22.5385 81.2633 22.5385 100.049C22.5385 118.834 37.6515 134.063 56.2941 134.063H156.33C169.535 134.063 180.24 123.276 180.24 109.969C180.24 96.6628 169.535 85.8761 156.33 85.8761C155.438 85.8761 154.558 85.9269 153.691 86.0227Z",
    fill: "url(#paint1_linear_429_17537)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.688 163.532C402.688 163.454 402.691 163.377 402.691 163.299C402.691 121.035 368.689 86.7723 326.745 86.7723C295.647 86.7723 268.918 105.611 257.174 132.578C254.195 132.061 251.133 131.788 248.008 131.788C218.401 131.788 194.4 155.974 194.4 185.807C194.4 215.641 218.401 239.827 248.008 239.827H406.879C427.851 239.827 444.852 222.695 444.852 201.563C444.852 180.43 427.851 163.299 406.879 163.299C405.463 163.299 404.065 163.38 402.688 163.532Z",
    fill: "url(#paint2_linear_429_17537)",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.352 193.029C194.06 287.839 46.6013 150.068 -28.0532 294.925",
    stroke: "#292B2E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeDasharray: "5.86 5.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.811 100.254C7.5 182.5 120.5 304.5 -100.26 373.521",
    stroke: "#292B2E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeDasharray: "5.26 5.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.48 187.272L270.138 162.657L330.455 119.827L275.48 187.272Z",
    fill: "#292B2E",
    stroke: "#292B2E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.48 187.272L281.762 170.639L330.332 119.854L275.48 187.272Z",
    fill: "white",
    stroke: "#292B2E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.089 167.719L243.079 159.222C242.23 158.965 242.164 157.788 242.979 157.438L330.401 119.839L271.089 167.719Z",
    fill: "white",
    stroke: "#292B2E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.311 178.636L281.763 170.543L330.332 119.854L316.459 177.932C316.337 178.444 315.822 178.759 315.311 178.636Z",
    fill: "white",
    stroke: "#292B2E",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.726 73.2556L141.05 96.7843L246.63 48.6982L152.726 73.2556Z",
    fill: "#292B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.649 97.6994C140.525 97.6452 140.413 97.5664 140.321 97.4678C140.228 97.3691 140.157 97.2528 140.111 97.1257C140.065 96.9987 140.045 96.8636 140.052 96.7286C140.06 96.5937 140.095 96.4617 140.155 96.3406L151.831 72.8116C151.895 72.6837 151.985 72.5709 152.095 72.4808C152.206 72.3907 152.335 72.3253 152.473 72.2892L246.377 47.7322C246.619 47.669 246.876 47.6988 247.097 47.8158C247.318 47.9328 247.487 48.1284 247.57 48.3641C247.654 48.5997 247.646 48.8582 247.549 49.0884C247.451 49.3186 247.271 49.5039 247.043 49.6075L141.463 97.6935C141.336 97.7517 141.197 97.7823 141.057 97.7833C140.916 97.7843 140.777 97.7557 140.649 97.6994ZM153.418 74.107L143.194 94.7109L235.647 52.6027L153.418 74.107Z",
    fill: "#292B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.638 47.3636L171.272 122.985L152.897 73.6943L127.568 44.0857L249.638 47.3636Z",
    fill: "white",
    stroke: "#292B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.431 72.5692L156.996 84.472L248.827 47.6459L152.431 72.5692Z",
    fill: "#292B2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.093 89.0866L156.582 84.7478L142.737 96.0695L158.093 89.0866Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_429_17537",
    x1: 0.5,
    y1: 0,
    x2: 20.8445,
    y2: 321.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FDEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0F4FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_429_17537",
    x1: 101.389,
    y1: 103.762,
    x2: 95.6761,
    y2: 62.3738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_429_17537",
    x1: 319.626,
    y1: 191.705,
    x2: 310.552,
    y2: 125.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_429_17537"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 1016,
    height: 258,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerReferrals);
export default __webpack_public_path__ + "static/media/banner_referrals.45f9131a039dc0a618b769b0dff1a634.svg";
export { ForwardRef as ReactComponent };